import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { Flex, FlexSpan, Icon, Table, TextInput } from "../../../ui";
import { TableHeaderContainer, TableStickyBodyCell } from "../../ParamsTable/styled";
import { TableRowMenu } from "../../TableRowMenu";
import { InfoIcon } from "../../InfoIcon";
const TABLE_PROPS = {
    opportunity_list: {
        title: "Возможности",
        color: "#6EE5B933",
        description: "Укажите рыночные возможности для развития вашего бизнеса",
    },
    strength_list: {
        title: "Сильные стороны",
        color: "#6EE5B933",
        description: "Укажите сильные стороны (преимущества) вашего бизнеса",
    },
    threat_list: {
        title: "Угрозы",
        color: "#EA394B33",
        description: "Укажите внешние факторы, которые могут помешать вашему бизнесу",
    },
    weakness_list: {
        title: "Слабые стороны",
        color: "#EA394B33",
        description: "Укажите слабые стороны (недостатки) вашего бизнеса",
    },
};
const MAX_TABLE_ROWS_COUNT = 6;
export const SwotTable = ({ tableName, values, onUpdateValues }) => {
    const [rowHover, setRowHover] = useState();
    const onPickMenuItem = useCallback((option, rowId) => {
        setRowHover(undefined);
        if (option.value === 1) {
            onUpdateValues?.({
                swot: {
                    ...values.swot,
                    [tableName]: Array.from({ length: MAX_TABLE_ROWS_COUNT }, (_, itemIndex) => {
                        return itemIndex === rowId ? "" : (values.swot[tableName]?.[itemIndex] || "");
                    }),
                },
            });
        }
    }, [onUpdateValues, tableName, values.swot]);
    return (_jsx(Table, { cellGap: 0, columns: [
            {
                id: "description",
                title: TABLE_PROPS[tableName]?.title,
                width: "100%",
                renderHead: column => {
                    return (_jsx(TableHeaderContainer, { background: TABLE_PROPS[tableName]?.color, width: "100%", mb: "0.125rem", children: _jsxs(Flex, { alignItems: "center", children: [_jsx(FlexSpan, { fontSize: "16px", fontWeight: 600, children: column.title }), _jsx(FlexSpan, { display: "flex", children: _jsx(InfoIcon, { content: TABLE_PROPS[tableName]?.description }) })] }) }));
                },
                renderBody: (_, rowId) => {
                    return (_jsxs(TableStickyBodyCell, { firstRow: rowId === 0, lastRow: rowId === MAX_TABLE_ROWS_COUNT - 1, firstCol: true, lastCol: true, isEditing: true, width: "calc(100% - 0.375rem)", onMouseOver: () => rowHover === undefined && setRowHover(rowId), onMouseLeave: () => setRowHover(undefined), children: [rowHover === rowId && (_jsx(TableRowMenu, { items: [
                                    {
                                        value: 1,
                                        label: "Очистить строку",
                                        prefix: _jsx(Icon, { icon: "backspace" }),
                                    },
                                ], onPick: option => onPickMenuItem(option, rowId) })), _jsx(TextInput, { style: { border: "none" }, inputStyle: { fontSize: "0.75rem", padding: "0 0.75rem" }, height: "2.5rem", maxLength: 100, value: values.swot[tableName]?.[rowId] ?? "", onChange: value => onUpdateValues?.({
                                    swot: {
                                        ...values.swot,
                                        [tableName]: Array.from({ length: MAX_TABLE_ROWS_COUNT }, (__, itemIndex) => {
                                            return itemIndex === rowId ? value : (values.swot[tableName]?.[itemIndex] || "");
                                        }),
                                    },
                                }) })] }));
                },
            },
        ], rows: Array.from({ length: MAX_TABLE_ROWS_COUNT }, () => ({ data: {} })) }));
};
